import React from "react";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="bg-charcoal text-white mt-24 relative overflow-hidden" data-testid="site-footer">
      <div className="container-lookers py-16 grid grid-cols-2 md:grid-cols-4 gap-10 relative z-10">
        <div>
          <div className="font-heading text-xs uppercase tracking-wide text-teal-400 mb-4">Shop</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li><Link to="/shop?sort=newest" className="hover:text-teal-300 transition-colors" data-testid="footer-new-arrivals">New Arrivals</Link></li>
            <li><Link to="/shop" className="hover:text-teal-300 transition-colors" data-testid="footer-shop-all">All Frames</Link></li>
            <li><Link to="/brands" className="hover:text-teal-300 transition-colors" data-testid="footer-designer-brands">Brands</Link></li>
            <li><Link to={`/shop?gender=${encodeURIComponent("Men's")}`} className="hover:text-teal-300 transition-colors" data-testid="footer-men">Men</Link></li>
            <li><Link to={`/shop?gender=${encodeURIComponent("Women's")}`} className="hover:text-teal-300 transition-colors" data-testid="footer-women">Women</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-heading text-xs uppercase tracking-wide text-teal-400 mb-4">Lookers</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li><Link to="/about" className="hover:text-teal-300 transition-colors" data-testid="footer-our-story">Our Story</Link></li>
            <li><Link to="/authenticity" className="hover:text-teal-300 transition-colors" data-testid="footer-authenticity">Authenticity Guarantee</Link></li>
            <li><Link to="/condition-guide" className="hover:text-teal-300 transition-colors" data-testid="footer-condition-guide">Condition Scale</Link></li>
            <li><Link to="/fit-guide" className="hover:text-teal-300 transition-colors" data-testid="footer-fit-guide">Find Your Fit</Link></li>
            <li><Link to="/share-your-look" className="hover:text-teal-300 transition-colors" data-testid="footer-share-your-look">Share Your Look · 15% Off</Link></li>
            <li><Link to="/sell" className="hover:text-teal-300 transition-colors" data-testid="footer-sell-to-lookers">Sell Your Frames</Link></li>
            <li><Link to="/gallery" className="hover:text-teal-300 transition-colors" data-testid="footer-customer-gallery">Customer Gallery</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-heading text-xs uppercase tracking-wide text-teal-400 mb-4">Help</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li><Link to="/shipping-returns" className="hover:text-teal-300 transition-colors" data-testid="footer-shipping">Shipping</Link></li>
            <li><Link to="/returns" className="hover:text-teal-300 transition-colors" data-testid="footer-returns">Returns &amp; Refunds</Link></li>
            <li><Link to="/authenticity" className="hover:text-teal-300 transition-colors" data-testid="footer-authenticity-guarantee">Authenticity Guarantee</Link></li>
            <li><Link to="/faqs" className="hover:text-teal-300 transition-colors" data-testid="footer-faqs">FAQs</Link></li>
            <li><Link to="/contact" className="hover:text-teal-300 transition-colors" data-testid="footer-contact-us">Contact</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-heading text-xs uppercase tracking-wide text-teal-400 mb-4">Follow</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li><a href="#" className="hover:text-teal-300 transition-colors" data-testid="footer-instagram">Instagram</a></li>
            <li><a href="#" className="hover:text-teal-300 transition-colors" data-testid="footer-tiktok">TikTok</a></li>
            <li><a href="#" className="hover:text-teal-300 transition-colors" data-testid="footer-facebook">Facebook</a></li>
          </ul>
        </div>
      </div>
      <div className="container-lookers py-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-zinc-500 relative z-10">
        <span>© Lookers. All Rights Reserved.</span>
        <div className="flex gap-4">
          <Link to="/privacy-policy" className="hover:text-teal-300 transition-colors" data-testid="footer-privacy-policy">Privacy Policy</Link>
          <Link to="/terms-conditions" className="hover:text-teal-300 transition-colors" data-testid="footer-terms">Terms &amp; Conditions</Link>
          <Link to="/returns" className="hover:text-teal-300 transition-colors" data-testid="footer-returns-bottom">Returns</Link>
        </div>
      </div>
    </footer>
  );
}
